export default function ContactSection() {
  return (
    <section id="contact" className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=warm%20dramatic%20spotlight%20stage%20atmosphere%20with%20orange%20and%20red%20tones%20breaking%20news%20press%20conference%20style%20dark%20moody%20background%20with%20light%20rays&width=1920&height=800&seq=contact-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-background-950/80"></div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white tracking-wide mb-4">
          你有猛料？
        </h2>
        <p className="text-lg md:text-xl text-white/70 mb-3">
          全网最敢说的吃瓜平台，就差你这一锤
        </p>
        <p className="text-sm text-white/50 mb-8 max-w-md mx-auto">
          投稿人信息严格加密保护，一经采纳即付爆料奖励
        </p>
        <a
          href="#"
          className="group inline-flex items-center gap-3 px-8 py-3.5 bg-accent-500 text-background-50 font-medium text-sm rounded-full hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
        >
          <span className="w-7 h-7 rounded-full bg-white/20 flex items-center justify-center">
            <i className="ri-send-plane-fill text-sm"></i>
          </span>
          立即投稿爆料
          <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
        </a>
      </div>
    </section>
  );
}